import clsx from 'clsx';

import { Button } from '@components/Button';

import Quote from '@assets/images/quote.svg';

import { Image } from '../Image';
import { Typography } from '../Typography';

interface TestimonialProps {
  data?: Testimonial;
  containerClassName?: string;
  contentClassName?: string;
  imgClassName?: string;
}

export const Testimonial: React.FC<TestimonialProps> = ({
  data,
  containerClassName,
  contentClassName,
  imgClassName,
}) => (
  <div
    className={clsx(
      'testimonial flex flex-wrap items-center gap-12',
      containerClassName,
    )}
  >
    <div className="flex min-w-full flex-1 gap-8 lg:min-w-[auto]">
      <div className="hidden flex-1 md:flex">
        <Quote />
      </div>

      <div
        className={clsx(
          'flex flex-col gap-8',
          data?.right_image ? 'items-start' : 'items-center',
        )}
      >
        <div className="flex flex-col gap-6">
          <div className="flex gap-8">
            <div className="flex md:hidden">
              <Quote />
            </div>

            <Typography variant="h4" markdown>
              {data?.title}
            </Typography>
          </div>

          <Typography
            variant="subtitle2"
            className={clsx(contentClassName)}
            markdown
          >
            {data?.content}
          </Typography>
        </div>

        <div
          className={clsx(
            'flex flex-col',
            data?.right_image ? 'items-start gap-1' : 'items-center gap-2',
          )}
        >
          <div className="h-16 w-16">
            <Image src={data?.image} className="rounded-full" />
          </div>
          <Typography variant="body1" className="font-bold text-neutral-900">
            {data?.author_name}
          </Typography>
          <Typography variant="body1" className="text-neutral-500">
            {data?.author_title}
          </Typography>
        </div>

        {data?.link && (
          <Button size="large" href={data?.link?.href}>
            {data?.link.label}
          </Button>
        )}
      </div>
    </div>

    {data?.right_image && (
      <div
        className={clsx(
          '-ml-8 flex min-w-[100vw] md:mx-auto md:min-w-[auto]',
          imgClassName,
        )}
      >
        <Image
          src={data?.right_image}
          className={clsx(
            'min-h-[20rem] flex-1 object-contain md:rounded-md',
            imgClassName,
          )}
        />
      </div>
    )}
  </div>
);
